import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { RecertAssessmentQuestionnaireItem } from '../../types/questionnaire'

export const SUPERVISORY_REVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_ID_BADGE]: QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_HONORING_RIGHTS]:
    QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_EMERGENCY_PROTOCOL]:
    QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_HYGIENE_PRECAUTIONS]:
    QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_REPORTING_CHANGES]:
    QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_GRIEVANCE_COMPLAINT]:
    QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_POC_DOC_REVIEWED_WITH_CAREGIVER]:
    QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_PPE_ACCESS]: QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_SUPERVISION_OBSERVED]:
    QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_TASK_OBSERVED]:
    QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_PATIENT_STATUS]:
    QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_COMMENTS]: QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_EDUCATION_CAREGIVER_EDUCATION_TOPIC]:
    QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_EDUCATION_EDUCATION_PROVIDED]:
    QuestionnaireAnswerType.STRING,
  [RecertAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_INITIALS_AUTHORIZATION]:
    QuestionnaireAnswerType.STRING
}
